import App from "./App";
import '../../i18n';

export default function Document () {
    return (<App />)
}